<template>
    <div>
        <div>
            <line-chart v-if="mGraphType === 'Linha'" :g-data-set="mDataSet" :g-labels="mLabels"></line-chart>
            <bar-chart v-if="mGraphType === 'Barra'" :g-data-set="mDataSet" :g-labels="mLabels"></bar-chart>
        </div>
    </div>
</template>

<script>
    import LineChart from './LineChart';
    import BarChart from './BarChart';
    export default {
        name: "DashboardGraph",

        // props: ['mBorderColor', 'mColor', 'mLabel', 'mRows', 'mLabels', 'mDataSet'],
        // props: ['mDataSet'],
        props: {
            mDataSet:{
                type: String,
            },
            mLabels:{
                tye: String,
            },
            mGraphType:{
                type: String,
            }
        },

        components: {
            LineChart,
            BarChart,
        }
    }
</script>

<style scoped>

</style>